import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
    return (
        <footer className="footer">
            <Container style={{paddingTop:'70px'}}>
                <Row className="align-items-center">
                    <Col size={12} sm={6}>
                        <img src={logo} alt="Logo" />
                    </Col>
                    <Col size={12} sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                            <a target="__blank"  href="https://www.linkedin.com/in/chaudharykrishna/"><img src={navIcon1} alt="LinkedIn" /></a>
                            <a target="__blank" href="https://www.facebook.com/chaudharyykrishna"><img src={navIcon2} alt="FaceBook" /></a>
                            <a target="__blank" href="https://www.instagram.com/_chaudharykrishna__/"><img src={navIcon3} alt="Instagram" /></a>
                        </div>
                        <p>Copyright 2024. All Rights Reserved</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}
